export const CustomEvents = {
    'JSONObjectChanged': 'JSONObjectChanged',
    'DeleteFile': 'DeleteFile',
    'ArticolChanged': 'ArticolChanged',
}